'use client';
import { useCallback, useState } from 'react';

import { useAuth } from '@/hooks';
import { useAppDispatch } from '@/store';
import { openModal } from '@/store/slices/ui.slice';
import { EventMarket, EventOutcome, Market, Outcome } from '@/types';

interface TradeModalState {
  isOpen: boolean;
  market: Market | EventMarket | null;
  outcome: Outcome | EventOutcome | null;
  isBuyOrder: boolean;
  teamColor?: string;
  forceDesktopVersion?: boolean;
}

const INITIAL_STATE: TradeModalState = {
  isOpen: false,
  market: null,
  outcome: null,
  isBuyOrder: true,
  teamColor: undefined,
  forceDesktopVersion: false,
};

export const useMarketTradeModal = () => {
  const dispatch = useAppDispatch();
  const { isAuthenticated, user } = useAuth();
  const [tradeModalState, setTradeModalState] = useState<TradeModalState>(INITIAL_STATE);

  const handleOpenTradeModal = useCallback(
    (
      market: Market | EventMarket,
      outcome: Outcome | EventOutcome,
      isBuyOrder: boolean,
      options?: { teamColor?: string; forceDesktopVersion?: boolean },
    ) => {
      if (isAuthenticated && !user?.isReferredUser) {
        dispatch(openModal('referral'));
        return;
      }
      setTradeModalState({
        isOpen: true,
        market,
        outcome,
        isBuyOrder,
        teamColor: options?.teamColor,
        forceDesktopVersion: options?.forceDesktopVersion,
      });
    },
    [isAuthenticated, user?.isReferredUser, dispatch],
  );

  const handleCloseTradeModal = useCallback(() => {
    setTradeModalState(INITIAL_STATE);
  }, []);

  return {
    tradeModalState,
    handleOpenTradeModal,
    handleCloseTradeModal,
    setTradeModalState,
  };
};
